// extracted by mini-css-extract-plugin
export default {"badge":"Icon_badge__pnBt5"};